import BadgesCell from "@/components/NewTable/BadgesCell";

export const columns = () => {
  return [
    {
      id: "code",
      accessorFn: (row) => `${row.code} - ${row.name}`,
      header: "Product",
    },
    {
      id: "brands",
      accessorFn: (row) => row.brands,
      header: "Brand",
      enableSorting: false,
      cell: ({ row }) => <BadgesCell items={row.original.brands} />,
    },
  ];
};
